function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer, menu-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const pdpAccordion = document.querySelector('.product__info-wrapper');

if (pdpAccordion) {
  pdpAccordion.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
    summary.addEventListener('click', (event) => {
      const currentDetails = event.currentTarget.closest('details');

      // Close all other details
      pdpAccordion.querySelectorAll('details[open]').forEach((otherDetails) => {
        if (otherDetails !== currentDetails) {
          otherDetails.removeAttribute('open');
          const otherSummary = otherDetails.querySelector('summary');
          if (otherSummary) {
            otherSummary.setAttribute('aria-expanded', 'false');
          }
        }
      });

      // Toggle aria-expanded on the clicked one
      const isOpen = currentDetails.hasAttribute('open');
      event.currentTarget.setAttribute('aria-expanded', !isOpen);
    });
  });
}

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(':focus-visible');
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    'ARROWUP',
    'ARROWDOWN',
    'ARROWLEFT',
    'ARROWRIGHT',
    'TAB',
    'ENTER',
    'SPACE',
    'ESCAPE',
    'HOME',
    'END',
    'PAGEUP',
    'PAGEDOWN',
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    'focus',
    () => {
      if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add('focused');
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {  
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });
    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this))
    );    
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    if (event.target.classList.contains('max-reached')) return;
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) {
      this.input.dispatchEvent(this.changeEvent);
      getCartData().then(cartData => {
          if (cartData) {                     
            window.cartBloom_requestStarted(cartData, event);
            window.cartBloom_requestComplete(cartData, event);
          }
      }); 
    } 
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const min = parseInt(this.input.min);
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle('disabled', value <= min);
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle('disabled', value >= max);
    }
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function throttle(fn, delay) {
  let lastCall = 0;
  return function (...args) {
    const now = new Date().getTime();
    if (now - lastCall < delay) {
      return;
    }
    lastCall = now;
    return fn(...args);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', path);

  for (var key in params) {
    var hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = '';
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach((summary) =>
      summary.addEventListener('click', this.onSummaryClick.bind(this))
    );
    this.querySelectorAll('button:not(.localization-selector)').forEach((button) =>
      button.addEventListener('click', this.onCloseButtonClick.bind(this))
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary'))
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach((details) => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach((submenu) => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);

    if (event instanceof KeyboardEvent) elementToFocus?.setAttribute('aria-expanded', false);
  }

  onFocusOut() {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement))
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector('.section-header');
    this.borderOffset =
      this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty(
      '--header-bottom-position',
      `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
    );
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    window.addEventListener('resize', this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
    window.removeEventListener('resize', this.onResize);
  }

  onResize = () => {
    this.header &&
      document.documentElement.style.setProperty(
        '--header-bottom-position',
        `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
      );
    document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
  };
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener('click', this.hide.bind(this, false));  
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
      if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) {
        // force autoplay for safari
        deferredElement.play();
      }
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter((element) => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slider || !this.nextButton || !this.sliderItemsToShow?.length) return;

    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent('slideChanged', {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
    
    const parent = this.closest('.feature_colle_wrapper');
    if (parent) {      
      const isFirstSlide = this.currentPage === 1;
      const isLastSlide = this.currentPage === this.totalPages;

      parent.classList.remove('show-left', 'show-right');

      if (isFirstSlide) {
        parent.classList.add('show-right');
      } else if (isLastSlide) {
        parent.classList.add('show-left');
      } else {
        parent.classList.add('show-left', 'show-right');
      }
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return element.offsetLeft + element.clientWidth <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === 'next'
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.setSlidePosition(this.slideScrollPosition);
  }

  setSlidePosition(position) {
    this.slider.scrollTo({
      left: position,
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.announcementBarSlider = this.querySelector('.announcement-bar-slider');
    // Value below should match --duration-announcement-bar CSS value
    this.announcerBarAnimationDelay = this.announcementBarSlider ? 250 : 0;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach((link) => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.announcementBarSlider && window.screen.width < 750) {
      this.announcementBarArrowButtonWasClicked = false;

      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.reducedMotion.addEventListener('change', () => {
        if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
      });

      [this.prevButton, this.nextButton].forEach((button) => {
        button.addEventListener(
          'click',
          () => {
            this.announcementBarArrowButtonWasClicked = true;
          },
          { once: true }
        );
      });
    }

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.autoplaySpeed = this.slider.dataset.speed * 1000;
   // this.addEventListener('mouseover', this.focusInHandling.bind(this));
   // this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    if (this.querySelector('.slideshow__autoplay')) {
      this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
      this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
      this.autoplayButtonIsSetToPlay = true;
      this.play();
    } else {
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      const shouldPause = this.reducedMotion?.matches || this.announcementBarArrowButtonWasClicked;
      shouldPause ? this.pause() : this.play();
        }
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    this.wasClicked = true;

    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) {
      this.applyAnimationToAnnouncementBar(event.currentTarget.name);
      return;
    }

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition =
        this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }

    this.setSlidePosition(this.slideScrollPosition);

    this.applyAnimationToAnnouncementBar(event.currentTarget.name);
  }

  setSlidePosition(position) {
    if (this.setPositionTimeout) clearTimeout(this.setPositionTimeout);
    this.setPositionTimeout = setTimeout(() => {
      this.slider.scrollTo({
        left: position,
      });
    }, this.announcerBarAnimationDelay);
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    // this.prevButton.removeAttribute('disabled');
    this.prevButton?.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    // this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    // this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
    const activeButton = this.sliderControlButtons[this.currentPage - 1];
    if (activeButton) {
      activeButton.classList.add('slider-counter__link--active');
      activeButton.setAttribute('aria-current', true);
    }
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
      this.play();
    } else if (!this.reducedMotion.matches && !this.announcementBarArrowButtonWasClicked) {
      this.play();
    }
  }

  focusInHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
        this.play();
      } else if (this.autoplayButtonIsSetToPlay) {
        this.pause();
      }
    } 
    else if (this.announcementBarSlider && this.announcementBarSlider.contains(event.target)) {
      this.pause();
    }
  }
  

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.sliderItemOffset;

    this.setSlidePosition(slideScrollPosition);
    
      this.applyAnimationToAnnouncementBar();
  }

  setSlideVisibility(event) {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll('a');
      if (index === this.currentPage - 1) {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.removeAttribute('tabindex');
          });
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.setAttribute('tabindex', '-1');
          });
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
    this.wasClicked = false;
  }

  applyAnimationToAnnouncementBar(button = 'next') {
    if (!this.announcementBarSlider) return;

    const itemsCount = this.sliderItems.length;
    const increment = button === 'next' ? 1 : -1;

    const currentIndex = this.currentPage - 1;
    let nextIndex = (currentIndex + increment) % itemsCount;
    nextIndex = nextIndex === -1 ? itemsCount - 1 : nextIndex;

    const nextSlide = this.sliderItems[nextIndex];
    const currentSlide = this.sliderItems[currentIndex];

    const animationClassIn = 'announcement-bar-slider--fade-in';
    const animationClassOut = 'announcement-bar-slider--fade-out';

    const isFirstSlide = currentIndex === 0;
    const isLastSlide = currentIndex === itemsCount - 1;

    const shouldMoveNext = (button === 'next' && !isLastSlide) || (button === 'previous' && isFirstSlide);
    const direction = shouldMoveNext ? 'next' : 'previous';

    if(currentSlide){
    currentSlide.classList.add(`${animationClassOut}-${direction}`);
    nextSlide.classList.add(`${animationClassIn}-${direction}`);

    setTimeout(() => {
      currentSlide.classList.remove(`${animationClassOut}-${direction}`);
      nextSlide.classList.remove(`${animationClassIn}-${direction}`);
    }, this.announcerBarAnimationDelay * 2);
  }
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
        (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
    this.addEventListener('load', this.JumptocurrentVariant());

  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    if (this.currentVariant?.id) {
      this.updateLegendInventory(this.currentVariant.id);
    }
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateVariantStatuses();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.filterMedia();       
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
      this.updatedescription();
      this.filterMedia_main();
      // this.updateStickyBarBuyButton();
    }
  }

  JumptocurrentVariant(){
    this.updateOptions();
    this.updateMasterId();
    this.filterMedia(); 
    this.filterMedia_main();   
    if (this.currentVariant?.id) {
      this.updateLegendInventory(this.currentVariant.id); 
    }
  }
  updateStickyBarBuyButton() {
    const stickyBar = document.querySelector('#stickybar_buybutton');
    if (!stickyBar) return;

    const requestedVariantId = this.currentVariant.id;

    fetch(`${this.dataset.url}?variant=${requestedVariantId}&section_id=${this.dataset.section}`)
      .then((response) => response.text())
      .then((htmlText) => {
        const html = new DOMParser().parseFromString(htmlText, 'text/html');
        const updatedStickyBar = html.querySelector('#stickybar_buybutton');

        if (updatedStickyBar && stickyBar) {
          // Toggle .disabled class
          if (updatedStickyBar.classList.contains('disabled')) {
            stickyBar.classList.add('disabled');
          } else {
            stickyBar.classList.remove('disabled');
          }

          // Update the label text only
          const newLabel = updatedStickyBar.querySelector('.p_buybutton-label');
          const stickyLabel = stickyBar.querySelector('.p_buybutton-label');
          if (newLabel && stickyLabel) {
            stickyLabel.textContent = newLabel.textContent;
          }
        }
      });
  }
  updatedescription(){    
    var element = document.getElementById(this.currentVariant.id);
    var element_SKU = document.querySelector(".quantity__rules_SKU");
    if (element_SKU) {
      element_SKU.innerText = this.currentVariant.sku;
    }
  }

  filterMedia() {     
    const container = document.getElementById(`MediaGallery-${this.dataset.section}`);   
    if (container){
      $(container).find('[thumbnail-color]').hide();
      $(container).find('[thumbnail-main]').hide();

      var selected_variant = this.currentVariant.sku;
      var selected_attribute_main = '[thumbnail-main="' + selected_variant + '"]';
      var selected_attribute = '[thumbnail-color="' + selected_variant + '"]';    
      if (selected_variant == selected_variant) { 
        $(container).find(selected_attribute).show();
        $(container).find(selected_attribute_main).show();
      } 
    }
    
  }
  filterMedia_main() {
    var selected_variant = this.currentVariant.sku;
    const container = document.getElementById(`MediaGallery-${this.dataset.section}`);
    if (!container) return;
    var selected_attribute = '[thumbnail-main="' + selected_variant + '"]';
    
    // Check if the element exists before trying to add a class
    var selectedElement = container.querySelector(selected_attribute);
    var unselectedElement = container.querySelector(".is-active");

    if (selectedElement) {
      // Add the 'is-active' class to the selected element
      unselectedElement.classList.remove('is-active');
      selectedElement.classList.add('is-active');
      selectedElement.scrollIntoView();
    } 
    var thumbnailId = container.querySelector('[thumbnail-main="' + selected_variant + '"]').getAttribute('thumbnail-id');
    const productWrapper = container.querySelector('[data-has-multiple-media="true"]');  
    if (productWrapper) {     
      // updateSlidebuttons(thumbnailId);    
    }
  }
  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);         
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }
  
  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGalleries = document.querySelectorAll(`[id^="MediaGallery-${this.dataset.section}"]`);
    mediaGalleries.forEach((mediaGallery) =>
      mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true)
    );

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector(`[data-media-id="${this.currentVariant.featured_media.id}"]`);
    modalContent.prepend(newMediaModal);  
    func_bloomreach_changeInfo(this.currentVariant);
    // func_bloomreach_changeVariant(this.currentVariant.id);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      const formId = productForm.getAttribute('id') || '';      
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
      const prod_id = productForm.dataset.productId;
      const prod_handle = productForm.dataset.productHandle;
      const prod_color = productForm.dataset.metaColor;
      const quickAddModal = productForm.closest('.quick-add-modal');      
      if (prod_id && productForm && (formId.includes('quick-add') || formId.includes('quickadd'))){              
        if (quickAddModal?.classList.contains('BR_item-true')) {        
          injectBloomreachData(null, prod_handle, productForm, prod_id, this.currentVariant, prod_color);        
        } else if (!quickAddModal?.classList.contains('recomm-true')) {          
          func_bloomreach_changeVariant_featured(prod_id, this.currentVariant);
        }
      }      
    });    
  }

  updateLegendInventory(variantId) {
    const inventorySource = document.getElementById(`VariantInventory-${this.dataset.section}`);
    if (!inventorySource) return;

    const inventoryData = JSON.parse(inventorySource.textContent || '{}');
    const variantInventory = inventoryData[variantId];
    if (!variantInventory) return;

    const slot = this.querySelector('.variant-inventory-slot');
    if (!slot) return;
    
    let html = '';
    if (!variantInventory.available) {
      html = window.variantStrings.soldOut;
      slot.classList.remove('low-in-stock');
    } else if (variantInventory.qty < window.VARIANT_LOW_STOCK_THRESHOLD) {
      html = window.variantStrings.inventory_low_stock;
      slot.classList.add('low-in-stock');
    }

    slot.dataset.stockStatus = html || '';
    slot.innerHTML = html || '';
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.querySelector(':checked').value === variant.option1
    );
    const inputWrappers = [...this.querySelectorAll('.product-form__input')];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [...option.querySelectorAll('input[type="radio"], option')];
      const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter((variant) => variant.available && variant[`option${index}`] === previousOptionSelected)
        .map((variantOption) => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.innerText = input.getAttribute('value');
      } else {
        input.innerText = window.variantStrings.unavailable_with_option.replace('[value]', input.getAttribute('value'));
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;

    fetch(
      `${this.dataset.url}?variant=${requestedVariantId}&section_id=${
        this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section
      }`
    )
      .then((response) => response.text())
      .then((responseText) => {
        // prevent unnecessary ui changes from abandoned selections
        if (this.currentVariant.id !== requestedVariantId) return;

        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(
          `price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const skuSource = html.getElementById(
          `Sku-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const skuDestination = document.getElementById(`Sku-${this.dataset.section}`);
        const inventorySource = html.getElementById(
          `Inventory-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const inventoryDestination = document.getElementById(`Inventory-${this.dataset.section}`);

        const volumePricingSource = html.getElementById(
          `Volume-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );

        const pricePerItemDestination = document.getElementById(`Price-Per-Item-${this.dataset.section}`);
        const pricePerItemSource = html.getElementById(
          `Price-Per-Item-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );

        const volumePricingDestination = document.getElementById(`Volume-${this.dataset.section}`);
        const qtyRules = document.getElementById(`Quantity-Rules-${this.dataset.section}`);
        const volumeNote = document.getElementById(`Volume-Note-${this.dataset.section}`);

        if (volumeNote) volumeNote.classList.remove('hidden');
        if (volumePricingDestination) volumePricingDestination.classList.remove('hidden');
        if (qtyRules) qtyRules.classList.remove('hidden');

        if (source && destination) destination.innerHTML = source.innerHTML;
        if (inventorySource && inventoryDestination) inventoryDestination.innerHTML = inventorySource.innerHTML;
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle('hidden', skuSource.classList.contains('hidden'));
        }

        if (volumePricingSource && volumePricingDestination) {
          volumePricingDestination.innerHTML = volumePricingSource.innerHTML;
        }

        if (pricePerItemSource && pricePerItemDestination) {
          pricePerItemDestination.innerHTML = pricePerItemSource.innerHTML;
          pricePerItemDestination.classList.toggle('hidden', pricePerItemSource.classList.contains('hidden'));
        }

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('hidden');

        if (inventoryDestination) inventoryDestination.classList.toggle('hidden', inventorySource.innerText === '');

        const addButtonUpdated = html.getElementById(`ProductSubmitButton-${sectionId}`);
        this.toggleAddButton(
          addButtonUpdated ? addButtonUpdated.hasAttribute('disabled') : true,
          window.variantStrings.soldOut
        );

        publish(PUB_SUB_EVENTS.variantChange, {
          data: {
            sectionId,
            html,
            variant: this.currentVariant,
          },
        });
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;
    const stickyBar = document.querySelector(`#stickybar_buybutton[data-section-id="${this.dataset.section}"]`);
    let stickyLabel = null;
    if (stickyBar) {
      stickyLabel = stickyBar.querySelector('.p_buybutton-label');
    } 

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
      if (stickyLabel) {
       if (stickyBar) stickyBar.classList.add('disabled');
        stickyLabel.textContent = text;
      }
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
      if (stickyLabel) {
        if (stickyBar) stickyBar.classList.remove('disabled');
        stickyLabel.textContent = window.variantStrings.addToCart;
      }
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(`Inventory-${this.dataset.section}`);
    const sku = document.getElementById(`Sku-${this.dataset.section}`);
    const pricePerItem = document.getElementById(`Price-Per-Item-${this.dataset.section}`);
    const volumeNote = document.getElementById(`Volume-Note-${this.dataset.section}`);
    const volumeTable = document.getElementById(`Volume-${this.dataset.section}`);
    const qtyRules = document.getElementById(`Quantity-Rules-${this.dataset.section}`);
    const stickyBar = document.querySelector(`#stickybar_buybutton[data-section-id="${this.dataset.section}"]`);
    let stickyLabel = null;
    if (stickyBar) stickyLabel = stickyBar.querySelector('.p_buybutton-label');

    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (stickyBar) stickyLabel.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('hidden');
    if (inventory) inventory.classList.add('hidden');
    if (sku) sku.classList.add('hidden');
    if (pricePerItem) pricePerItem.classList.add('hidden');
    if (volumeNote) volumeNote.classList.add('hidden');
    if (volumeTable) volumeTable.classList.add('hidden');
    if (qtyRules) qtyRules.classList.add('hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
  // getSelectedVariantOptions() {
  //   const optionNames = this.getVariantData()[0].options.map((_, index) => this.getVariantData()[0][`option${index + 1}`] && `option${index + 1}`);
  //   const selectedOptions = this.options;
  
  //   return optionNames.map((optionKey, index) => {
  //     const name = this.variantData[0].[`option${index + 1}_name`] || `Option ${index + 1}`;
  //     const value = selectedOptions[index];
  //     return { name, value };
  //   });
  // }

}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.classList.remove('disabled');
      } else {
        input.classList.add('disabled');
      }
    });
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
            this.remove();
          }

          if (html.querySelector('.grid__item')) {
            this.classList.add('product-recommendations--loaded');
          }
          const productCards = this.querySelectorAll('[data-product-id]');
          productCards.forEach(card => {
            const productId = card.dataset.productId;
            const functionName = `func_bloomreach_product_json_${productId}`;
            if (window[functionName]) {
              // Add a small delay to ensure DOM is fully rendered
              setTimeout(() => {
                window[functionName](500);
              }, 100);
            }
          });
        })
        .catch((e) => {
          console.error(e);
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 400px 0px' }).observe(this);
  }
}

customElements.define('product-recommendations', ProductRecommendations);
// dont'touch or remove
function getCartData() {
  return new Promise((resolve, reject) => {
    setTimeout(function(){
      fetch(`${routes.cart_url}.js`)
        .then(cartResponse => cartResponse.json())
        .then(cartData => {           
            resolve(cartData);
        })
        .catch(error => {
            console.error('Error fetching cart data:', error);
            reject(error);
        });
    }, 800);  
  });
}
// For mobile app
document.addEventListener('DOMContentLoaded', function () {
    const params = new URLSearchParams(window.location.search);

  if (params.get('webview') === 'true') {
    document.body.classList.add('is-webview');
  }
});
//
class BloomreachRecommendations extends HTMLElement {
  constructor() {
    super();
    this.campaignId = this.dataset.campaignId;
    this.limit = Number(this.dataset.limit || 10);
    this.fillWithRandom = this.dataset.fillRandom === 'true';
    this.strategy = this.dataset.strategy;
    this.sectionId = this.dataset.sectionId;
  }
  
  connectedCallback() {   
    if (!this.campaignId) return;

    const options = {
      recommendationId: this.campaignId,
      size: this.limit,
      fillWithRandom: this.fillWithRandom,   
      strategy: this.strategy,
      // catalogAttributesWhitelist: [
      //   'title'      
      // ],
      callback: this.onRecommendationsLoaded.bind(this)
    };

    const currentProductId = (window.meta && window.meta.product && window.meta.product.id);   
    if (currentProductId) {
      options.items = {
        [currentProductId]: 1
      };
    }

    exponea.getRecommendation(options);
  }

  onRecommendationsLoaded(data) {       
    if (!data || data.length === 0) {
      this.hideSection();
      return;  
    } 

    // const recommendedIds = data.map(item => item.item_id);     
    const recommendedIds = data
      .map(item => {    
        return String(item.parent_id || item.shopify_id || item.item_id || '');   
        // if (item.shopify_id) {
        //   return String(item.shopify_id);
        // }              
        // if (item.item_id && String(item.item_id).length > 10) {
        //   return String(item.item_id);
        // }
        // return null;
      })
      .filter(Boolean);   
    this.loadProducts(recommendedIds);   
  }

  async loadProducts(recommendedIds) {
    const query = recommendedIds.map(id => `id:${id}`).join(" OR ");
    const url = `${Shopify.routes.root}search?type=product&q=${query}&section_id=${this.sectionId}`;

    try {
      const response = await fetch(url);
      const html = await response.text();
      const tempDiv = new DOMParser().parseFromString(html, 'text/html');
      const newContent = tempDiv.querySelector('bloomreach-products');
      const productItems = newContent?.querySelectorAll('li[data-product-id]');

      if (newContent && productItems && productItems.length > 0) {
        this.replaceChildren(...document.importNode(newContent, true).childNodes);
        setTimeout(() => {         
          this.initSliderIndicator();   
          injectBloomreachData(this, null, null, null, null, null, null);
          // this.bindProductClickTracking();
          this.enableAlgoliaClickTracking();
          this.toggleArrows(productItems.length);
        }, 100);
        handleQuickAddPositioning();
      }
      else {
        this.hideSection();
      }
    } catch (error) {
      console.warn('Failed to load bloomreach products:', error);
      this.hideSection();
    }
  }
  initSliderIndicator() {
    const slider = document.getElementById(`Slider-${this.sectionId}`);
    const sliderIndicator = document.getElementById(`Slider-${this.sectionId}_slider-indicator`);   
    if (!slider || !sliderIndicator) return;
  
    const indicatorWidth = (slider.offsetWidth * 0.2);
    sliderIndicator.style.width = indicatorWidth + 'px';

    const sidePadding = 13;
  
    slider.addEventListener('scroll', function () {
      const maxScroll = slider.scrollWidth - slider.offsetWidth;
      // const scrollPercentage = (slider.scrollLeft / (slider.scrollWidth - slider.offsetWidth)) * 100;
      const scrollPercentage = maxScroll > 0 ? slider.scrollLeft / maxScroll : 0;
      const trackWidth = slider.offsetWidth - 2 * sidePadding - indicatorWidth;
      
      let leftPos = sidePadding + scrollPercentage * trackWidth;
      if (scrollPercentage <= 0) leftPos = sidePadding;
      if (scrollPercentage >= 1) leftPos = slider.offsetWidth - sidePadding - indicatorWidth;
      sliderIndicator.style.left = leftPos + "px";     
    });
  }
  enableAlgoliaClickTracking() {
    // Use delegation so future re-renders also work
    this.addEventListener('click', function(e) {
      const link = e.target.closest('.card__content a');
      if (!link) return;

      const userToken = localStorage.getItem('_ALGOLIA_USER_TOKEN') || 'anonymous';
      const objectID = link.dataset.variantId;
      const index = window.algoliaShopify.dynamicIndexName || `${window.algoliaShopify.config.index_prefix}products`;
      const authenticatedUserToken = window.algoliaShopify?.authenticatedUserToken || undefined;
      aa('clickedObjectIDs', {
        userToken: userToken,
        authenticatedUserToken: authenticatedUserToken,
        eventName: 'clickedObjectIDs',
        index: index,
        objectIDs: [objectID]
      });
    });
  }
  hideSection() {
    const section = document.getElementById(`shopify-section-${this.sectionId}`);
    if (section) {
      section.style.display = 'none';
    }
  }
  toggleArrows(productCount) {
    const prevBtn = document.querySelector(`#shopify-section-${this.sectionId} .slider-button--prev`);
    const nextBtn = document.querySelector(`#shopify-section-${this.sectionId} .slider-button--next`);
    if (!prevBtn || !nextBtn) return;

    if (productCount <= 6) {
      prevBtn.style.display = 'none';
      nextBtn.style.display = 'none';
    } else {
      prevBtn.style.display = '';
      nextBtn.style.display = '';
    }
  }

  // bindProductClickTracking() {
  //   this.querySelectorAll('.product-grid .card__content a').forEach((productLink) => {
  //     productLink.addEventListener('click', function (e) {
  //       const objectID = this.dataset.variantId;

  //       if (!objectID) return;
  //       const userToken = localStorage.getItem('_ALGOLIA_USER_TOKEN') || 'anonymous'; 
  //       aa('clickedObjectIDs', {        
  //         userToken: userToken,
  //         eventName: 'clickedObjectIDs',
  //         index: `${window.algoliaShopify.config.index_prefix}products`,
  //         objectIDs: [objectID]
  //       });
  //     });
  //   });
  // }
}
customElements.define('bloomreach-products', BloomreachRecommendations);

function injectBloomreachData(container = null, quickViewHandle = null, quickViewHandleForm = null, quickViewItemId = null, curVID = null, metaColor = null, categoryData) { 
  if (container !== null && quickViewHandle === null) {
    container.querySelectorAll('[data-bloomreach-product]').forEach((el) => {
      const handle = el.getAttribute('data-product-handle');
      const productId = el.getAttribute('data-product-id');
      const metaColor = el.getAttribute('data-meta-color');
      const categoryData = {
        category_level_1: el.getAttribute('data-cat-level-1') || '',
        category_level_2: el.getAttribute('data-cat-level-2') || '',
        category_level_3: el.getAttribute('data-cat-level-3') || '',
        categories_path: el.getAttribute('data-cat-path') || '',
        category_id: el.getAttribute('data-cat-id') || '',
        categories_ids: (el.getAttribute('data-cat-ids') || '').split(',')  // returns array like ["cat_makeup", "cat_lips"]
      };
    
      if (!handle || document.getElementById(`bloomreach_product_json_${productId}`)) return;
      injectBloomreachItem(handle, productId, el, null, metaColor, categoryData);      
    });
  }
  else if (container === null && quickViewHandle !== null) {
    injectBloomreachItem(quickViewHandle, quickViewItemId, quickViewHandleForm, curVID, metaColor, categoryData);
  }  
}
function injectBloomreachItem(handle, productId, elOrFormContainer, curVID = null, metaColor, bloomCatData) { 
  const productFormBR = elOrFormContainer.tagName === 'FORM'
    ? elOrFormContainer
    : elOrFormContainer.querySelector(`form[data-id="product-form-${productId}"]`);

  if (!productFormBR) return;
  
  fetch(`${window.Shopify.routes.root}products/${handle}.js`)
    .then(response => response.json())
    .then(product => {
      // const variant = product.variants.find(v => v.available) || product.variants[0];
    
      const variant = curVID
        ? product.variants.find(v => v.id === curVID.id)
        : product.variants.find(v => v.available) || product.variants[0];
            
      const getVariantColor = (metaColor, variant, product) => {
          // Check metaColor first
          if (metaColor && metaColor.trim() !== '') {
            return metaColor;
          }
          if (!variant) return;
          // Find color option index dynamically
          const colorKeywords = ['color', 'colour'];
          const colorOptionIndex = product?.options?.findIndex(option => 
            colorKeywords.some(keyword => 
              option.name.toLowerCase().includes(keyword)
            )
          ) ?? -1;
          
          if (colorOptionIndex === -1) return '';                
          const colorValue = variant?.options?.[colorOptionIndex] || 
                            variant?.[`option${colorOptionIndex + 1}`];
          
          return colorValue || '';
        };
        
      const finalColor = getVariantColor(metaColor, variant, product);      
      const sizeOptionIndex = product.options.findIndex(opt => opt.name === 'Size' || opt.name === 'مقاس');
      const currentVariantLabel = variant.options[sizeOptionIndex] || null;
      const tags = product.tags || [];

      const price = ((parseFloat(variant.price) || 0) / 100).toFixed(2);
      const compare_at_price = (variant.compare_at_price && parseFloat(variant.compare_at_price) > parseFloat(variant.price))
      ? (parseFloat(variant.compare_at_price) / 100).toFixed(2)
      : '';

      const bloomreach_item_json = {
        product_id: variant.barcode,
        variant_id: variant.sku,
        sku_id: variant.sku,
        shopify_parent_id: product.id,
        shopify_variant_id: variant.id,
        title: product.title,
        price: price,
        price_local_currency: price,
        compare_at_price,
        brand: product.vendor,       
        product_type: product.type,
        color: finalColor || '',
        size: currentVariantLabel,
        tags,
        ...bloomCatData        
      };    
      const existingInput = productFormBR.querySelector(`#bloomreach_product_json_${product.id}`);
      if (existingInput){
        if (curVID) {
          existingInput.remove();
        }
        else {
          return;
        }
      } 

      const input = document.createElement("input");
      input.type = "hidden";
      input.name = `properties[_bloomreach_product_json]`;
      input.id = `bloomreach_product_json_${product.id}`;
      input.value = JSON.stringify(bloomreach_item_json);
      productFormBR.appendChild(input);
    })
    .catch(error => {
      console.error(`Failed to fetch product ${handle}:`, error);
    });
}

// Algolia tracking event code for wishlist page
document.addEventListener("DOMContentLoaded", function() { 
  document.querySelectorAll('.product-grid .card__content a').forEach((productLink) => {
    productLink.addEventListener('click', function (e) {    
      const userToken = localStorage.getItem('_ALGOLIA_USER_TOKEN') || 'anonymous';  
      const objectID = this.dataset.variantId;          
      const index = window.algoliaShopify.dynamicIndexName || `${window.algoliaShopify.config.index_prefix}products`; 
      const authenticatedUserToken = window.algoliaShopify?.authenticatedUserToken || undefined;       
      aa('clickedObjectIDs', {       
        userToken: userToken,
        authenticatedUserToken: authenticatedUserToken,
        eventName: 'clickedObjectIDs',
        index: index,
        objectIDs: [objectID]
      });
    });
  });
});
function sendConvertedObjectIDs(objectIDs, name_event) { 
  const userToken = localStorage.getItem('_ALGOLIA_USER_TOKEN');
  const index = window.algoliaShopify.dynamicIndexName || `${window.algoliaShopify.config.index_prefix}products`; 
  const authenticatedUserToken = window.algoliaShopify?.authenticatedUserToken || undefined; 
    aa('convertedObjectIDs', {
      userToken: userToken,
      authenticatedUserToken: authenticatedUserToken,
      eventName: 'convertedObjectIDs',
      index: index,
      objectIDs: [objectIDs]
    });
}
function sendConvertedObjectIDsAfterSearch(objectID, name_event, properties) {
  const queryID = sessionStorage.getItem('algolia_queryID');
  const index = window.algoliaShopify.dynamicIndexName || `${window.algoliaShopify.config.index_prefix}products`; 
  const storedObjectID = sessionStorage.getItem('algolia_objectID');
  const userToken = localStorage.getItem('_ALGOLIA_USER_TOKEN');
  const authenticatedUserToken = window.algoliaShopify?.authenticatedUserToken || undefined;
  const rawValue = (properties.price || 0) * (properties.quantity || 1);
  const value = Number(rawValue.toFixed(2));
  if (queryID && index && userToken && storedObjectID) {
    aa('convertedObjectIDsAfterSearch', {
      userToken: userToken,
      authenticatedUserToken: authenticatedUserToken,
      eventName: 'convertedObjectIDsAfterSearch',
      index: index,     
      queryID: queryID,
      objectIDs: [objectID],
      objectData: [
        {
          price: properties.price || 0,
          discount: properties.discount_value || 0,
          quantity: properties.quantity
        }
      ],
      value: value,
      currency: properties.currency
    });
    aa('addedToCartObjectIDsAfterSearch', {
      userToken: userToken,
      authenticatedUserToken: authenticatedUserToken,
      eventName: 'addedToCartObjectIDsAfterSearch',
      index: index,                      
      queryID: queryID,
      objectIDs: [objectID],
      objectData: [
        {
          price: properties.price || 0,
          discount: properties.discount_value || 0,
          quantity: properties.quantity
        }
      ],
        value: value,
        currency: properties.currency
    });
  }
}

function sendAddedToCartObjectIDs(objectIDs, name_event, properties) { 
  const userToken = localStorage.getItem('_ALGOLIA_USER_TOKEN');
  const index = window.algoliaShopify.dynamicIndexName || `${window.algoliaShopify.config.index_prefix}products`;
  const authenticatedUserToken = window.algoliaShopify?.authenticatedUserToken || undefined;
  const rawValue = (properties.price || 0) * (properties.quantity || 1);
  const value = Number(rawValue.toFixed(2));
    aa('addedToCartObjectIDs', {
      userToken: userToken,   
      authenticatedUserToken: authenticatedUserToken,
      eventName: 'addedToCartObjectIDs',
      index: index,
      objectIDs: [objectIDs],
      objectData: [
        {
          price: properties.price || 0,
          discount: properties.discount_value || 0,
          quantity: properties.quantity
        }
      ],
      value: value,
      currency: properties.currency
    });
}
// For cartQTY update
function sendAddedToCart(objectIDs, properties) { 
  const userToken = localStorage.getItem('_ALGOLIA_USER_TOKEN');
  const rawValue = (properties.price || 0) * (properties.quantity || 1);
  const value = Number(rawValue.toFixed(2));
    aa('addedToCartObjectIDs', {
      userToken: userToken,   
      eventName: 'addedToCartObjectIDs',
      index: properties.indexId || window.algoliaShopify.dynamicIndexName || `${window.algoliaShopify.config.index_prefix}products`,
      objectIDs: [objectIDs],
      objectData: [
        {
          price: properties.price || 0,
          discount: properties.discount_value || 0,
          quantity: properties.quantity
        }
      ],
      value: value,
      currency: properties.currency
    });
    aa('convertedObjectIDs', {
    userToken: userToken,      
    eventName: 'convertedObjectIDs', 
    index: properties.indexId || window.algoliaShopify.dynamicIndexName || `${window.algoliaShopify.config.index_prefix}products`,      
    objectIDs: [objectIDs]
  });
}
function sendAfterSearchCart(objectID, properties) {
  const queryID = properties.queryId;  
  const index = properties.indexId || window.algoliaShopify.dynamicIndexName || `${window.algoliaShopify.config.index_prefix}products`;
  const userToken = localStorage.getItem('_ALGOLIA_USER_TOKEN');  
  const rawValue = (properties.price || 0) * (properties.quantity || 1);
  const value = Number(rawValue.toFixed(2));
  if (queryID && index && userToken) {    
    aa('convertedObjectIDsAfterSearch', {
      userToken: userToken,
      eventName: 'convertedObjectIDsAfterSearch',
      index: index,     
      queryID: queryID,
      objectIDs: [objectID],
      objectData: [
        {
          price: properties.price || 0,
          discount: properties.discount_value || 0,
          quantity: properties.quantity
        }
      ],
      value: value,
      currency: properties.currency
    });
    aa('addedToCartObjectIDsAfterSearch', {
      userToken: userToken,      
      eventName: 'addedToCartObjectIDsAfterSearch',
      index: index,                      
      queryID: queryID,
      objectIDs: [objectID],
      objectData: [
        {
          price: properties.price || 0,
          discount: properties.discount_value || 0,
          quantity: properties.quantity
        }
      ],
        value: value,
        currency: properties.currency
    });
  }
}
// find category data

window.buildBloomCategories = function(productId, collectionList) {  
  const bloomDataKey = `bloomDataCat_${productId}`;
  window[bloomDataKey] = window[bloomDataKey] || {};
  const bloomDataCat = window[bloomDataKey];

  // const bloom_collectionList_for_current_product = collectionList.map(handle => ({ handle: handle }));
  const bloom_collectionList_for_current_product = collectionList.map(item => {
    return typeof item === 'string' ? { handle: item } : item;
  });
  
  if (!collectionList || !collectionList.length) return;
  
  const class_lvl1 = '[data-lvl1]';
  const class_lvl2 = '[data-lvl2]';
  const class_lvl3 = '[data-lvl3]';

  const found_lvl3 = forgetBloomreachCollections('lvl3', `a${class_lvl3}[href="/collections/__collectionHandle__"]`, bloom_collectionList_for_current_product);
  if (found_lvl3) return;

  const found_lvl2 = forgetBloomreachCollections('lvl2', `a${class_lvl2}[href="/collections/__collectionHandle__"]`, bloom_collectionList_for_current_product);
  if (found_lvl2) return;

  function forgetBloomreachCollections(lvl, selectorTemplate, bloom_collectionList) {
    for (let i = 0; i < bloom_collectionList.length; i++) {
      let selector = selectorTemplate.replace('__collectionHandle__', bloom_collectionList[i].handle);     
      
      if (window.shopLocale === 'ar') {
        selector = selector.replace('/collections/', '/ar/collections/');
      }

      const matches = document.querySelectorAll(selector);
      if (matches.length) {
        getBloomreachCreateBreadcrumbs(lvl, matches[0]);
        return true;
      }
    }
    return false;
  }

  function getBloomreachCreateBreadcrumbs(lvl, el) {
    const item_lvl_3 = lvl === 'lvl3' ? el : null;
    const item_lvl_2 = el.closest('[data-parent-lvl2]')?.querySelector('[data-lvl2]');
    const item_lvl_1 = el.closest('[data-parent-lvl1]')?.querySelector('[data-lvl1]'); 

    bloomDataCat.category_level_3 = item_lvl_3?.innerText?.trim() || item_lvl_3?.textContent?.trim() || item_lvl_3?.text?.trim() || '';
    bloomDataCat.category_level_2 = item_lvl_2?.innerText?.trim() || item_lvl_2?.textContent?.trim() || item_lvl_2?.text?.trim() || '';
    bloomDataCat.category_level_1 = item_lvl_1?.innerText?.trim() || item_lvl_1?.textContent?.trim() || item_lvl_1?.text?.trim() || '';

    bloomDataCat.categories_path = `${bloomDataCat.category_level_1} > ${bloomDataCat.category_level_2} > ${bloomDataCat.category_level_3}`;
    bloomDataCat.category_id = item_lvl_3?.getAttribute('data-coll-id') || '';
    bloomDataCat.categories_ids = [];

    if (item_lvl_1?.getAttribute('data-coll-id')) bloomDataCat.categories_ids.push(item_lvl_1.getAttribute('data-coll-id'));
    if (item_lvl_2?.getAttribute('data-coll-id')) bloomDataCat.categories_ids.push(item_lvl_2.getAttribute('data-coll-id'));
    if (item_lvl_3?.getAttribute('data-coll-id')) bloomDataCat.categories_ids.push(item_lvl_3.getAttribute('data-coll-id'));   
  }
};

// store data of search 
document.addEventListener('click', function (e) {
  const link = e.target.closest('.algolia-product-link');
  if (!link) return;

  const queryID = link.getAttribute('data-algolia-queryid');
  const objectID = link.getAttribute('data-algolia-objectid');
  const indexName = window.algoliaShopify.dynamicIndexName || link.getAttribute('data-algolia-index');
  const position = link.getAttribute('data-algolia-position');
  // Only track if queryID exists (i.e., came from search, not PLP)
  const isSearch = link.dataset.source === 'search';
  if (isSearch && queryID && objectID && indexName) {
    sessionStorage.setItem('algolia_queryID', queryID);
    sessionStorage.setItem('algolia_objectID', objectID);
    sessionStorage.setItem('algolia_index', indexName);
  }
});
const processedLabels = new WeakSet();
document.addEventListener('click', function (e) {
  const label = e.target.closest('.ais-RefinementList-label');
  if (!label || processedLabels.has(label)) return;

  processedLabels.add(label);

  // Clear from the set after short time to allow future clicks
  setTimeout(() => {
    processedLabels.delete(label);
  }, 500); 

  const checkbox = label.querySelector('input[type="checkbox"]');
  if (!checkbox) return;

  // Slight delay to allow InstantSearch to apply the refinement state
  setTimeout(() => {
    const selectedCheckboxes = document.querySelectorAll('.ais-RefinementList-checkbox:checked');

    const filters = Array.from(selectedCheckboxes).map(input => {
      const facetValue = input.getAttribute('data-value');
      
      // Try to determine facet name from class (ais-facet-<facet-name>-container)
      const facetWrapper = input.closest('.ais-facet-dropdown-wrapper') || input.closest('.ais-facet');
      const facetLabel = facetWrapper?.querySelector('label[for]');
      const facetKey = facetLabel?.getAttribute('for') || 'unknown_facet';         

      return `${facetKey}:${encodeURIComponent(facetValue)}`;
    });

    if (!filters.length) return;

    const userToken = localStorage.getItem('_ALGOLIA_USER_TOKEN') || 'anonymous';
    const index = window.algoliaShopify.dynamicIndexName || `${window.algoliaShopify.config.index_prefix}products`;
    const authenticatedUserToken = window.algoliaShopify?.authenticatedUserToken || undefined;
    const chunkSize = 10;
    for (let i = 0; i < filters.length; i += chunkSize) {
      const chunk = filters.slice(i, i + chunkSize);   
      aa('clickedFilters', {
        userToken: userToken,
        authenticatedUserToken: authenticatedUserToken,
        index: index, 
        eventName: 'clickedFilters',
        filters: chunk
      });
    }
    fireViewCategory();
  }, 100);
});
function updateColorLegend(radioInput, option_name, sectionId, prod_id) {
  var legend = document.getElementById(`colorLegend_${prod_id}-${sectionId}`);
  if (legend) {
    legend.textContent = option_name + ': ' + radioInput.value;
  }        
}
document.addEventListener('DOMContentLoaded', () => {
  const storedHandle = sessionStorage.getItem('algolia_autocomplete_product_handle');
  const currentHandle = window.location.pathname.split('/products/')[1]?.split('/')[0];
  if (storedHandle && storedHandle !== currentHandle) {
    sessionStorage.removeItem('algolia_autocomplete_product_handle');    
  }
});
function fireViewCategory() {
  if (window.location.pathname.includes('/collections/')) {    
    setTimeout(() => {
      func_exponia_view_category();
    }, 400);
  }  
}
document.addEventListener("DOMContentLoaded", () => {
  const menuContainer = document.querySelector(".scrollable-header ul.list-menu--inline");
  const leftArrow = document.querySelector(".menu-arrow.left");
  const rightArrow = document.querySelector(".menu-arrow.right");

  if (!menuContainer || !leftArrow || !rightArrow) return;

  function updateArrows() {   
    leftArrow.style.display = menuContainer.scrollLeft <= 0 ? "none" : "block";
    const atEnd = menuContainer.scrollLeft + menuContainer.clientWidth >= menuContainer.scrollWidth - 1;
    rightArrow.style.display = atEnd ? "none" : "block";
  }

  leftArrow.addEventListener("click", () => {
    menuContainer.scrollTo({ left: 0, behavior: "smooth" });
    setTimeout(updateArrows, 400);
  });

  rightArrow.addEventListener("click", () => {
    menuContainer.scrollBy({ left: menuContainer.scrollWidth, behavior: "smooth" });
    setTimeout(updateArrows, 400);
  });

  menuContainer.addEventListener("scroll", updateArrows);
  window.addEventListener("resize", updateArrows);

  updateArrows();
  handleQuickAddPositioning();
});
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.login_p_toggle').forEach(toggle => {
    toggle.addEventListener('click', function () {
      const input = document.querySelector(this.dataset.toggle);
      const isPassword = input.type === 'password';
      input.type = isPassword ? 'text' : 'password';

      // Toggle icon
      this.innerHTML = isPassword ? `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M3 10C3.85907 11.041 4.87049 11.9462 6 12.685M6 12.685C7.2165 13.4787 8.57462 14.0305 10 14.31C11.3213 14.5639 12.6787 14.5639 14 14.31C15.4254 14.0305 16.7835 13.4787 18 12.685M6 12.685L4.5 14.5M21 10C20.1409 11.041 19.1295 11.9462 18 12.685M18 12.685L19.5 14.5M10 14.309L9.5 16.5M14 14.309L14.5 16.5" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>` : `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M3 12C8.4 4 15.6 4 21 12C15.6 20 8.4 20 3 12Z" stroke="black" stroke-width="1.5" stroke-linejoin="round"/>
        <path d="M15 12C15 12.7956 14.6839 13.5587 14.1213 14.1213C13.5587 14.6839 12.7956 15 12 15C11.2044 15 10.4413 14.6839 9.87868 14.1213C9.31607 13.5587 9 12.7956 9 12C9 11.2044 9.31607 10.4413 9.87868 9.87868C10.4413 9.31607 11.2044 9 12 9C12.7956 9 13.5587 9.31607 14.1213 9.87868C14.6839 10.4413 15 11.2044 15 12Z" stroke="black" stroke-width="1.5" stroke-linejoin="round"/>
        </svg>`;
    });
  });
});
// for reset/register password
function validatePassword(password) {
  return {
    hasNumber: /\d/.test(password),
    hasMinLength: password.length >= 8
  };
}
// badges
class ProductBadges extends HTMLElement {
  constructor() {
    super();   
  }
  connectedCallback() {
    this.renderBadges();
  }
  renderBadges() {
    const configScript = document.getElementById('global-badge-config');    
    if (!configScript) return;

    const badgeConfig = JSON.parse(configScript.textContent || '{}');
    const tags = (this.dataset.productTags || '').split(',').map(tag => tag.trim());    
    const localeKey = document.documentElement.lang === 'ar' ? 'badge_ar' : 'badge_en';

    // Match tags with config and sort by block order
    const matched = Object.entries(badgeConfig)
      .filter(([tag, config]) => tags.includes(tag) && config[localeKey])
      .sort((a, b) => a[1].order - b[1].order);

    const badgesHTML = matched
      .map(([tag, config]) => {
        const imageUrl = config[localeKey];
        if (!imageUrl || imageUrl.trim() === '') return '';
        return `
          <li class="badge-promo badge--${tag}">
            <img src="${imageUrl}" alt="${config.label || ''}" loading="lazy" />
          </li>`;
      })
      .filter(Boolean)
      .join('');

    if (badgesHTML) {
      this.innerHTML = `<ul class="product-badges list-unstyled">${badgesHTML}</ul>`;
    }
  }
}

customElements.define('product-badges', ProductBadges);
// promo-label
class PromoLabel extends HTMLElement {
  connectedCallback() {
    const container = this.closest('.card__information-promo');
    if (!container) return;

    // Only desktop
    if (!window.matchMedia('(min-width: 1024px)').matches) return;

    requestAnimationFrame(() => {
      if (this.scrollWidth > container.clientWidth) {
        this._originalWidth = this.scrollWidth;
        this._setupClones();
        this._setupHover(container);
      }
    });
  }

  _setupClones() {
    if (this._track) return;

    const originalText = this.textContent.trim();

    // original span (for idle ellipsis)
    const original = document.createElement('span');
    original.classList.add('marquee-original');
    original.textContent = originalText;

    // marquee track with 3 clones
    const track = document.createElement('span');
    track.classList.add('marquee-track');

    for (let i = 0; i < 3; i++) {
      const span = document.createElement('span');
      span.classList.add('marquee-text');
      span.textContent = originalText;
      track.appendChild(span);
    }

    this.innerHTML = '';
    this.append(original, track);

    this._track = track;
  }

  _setupHover(container) {
    container.addEventListener('mouseenter', () => this.startMarquee());
    container.addEventListener('mouseleave', () => this.stopMarquee());
  }

  startMarquee() {
    if (!this._track || !this._originalWidth) return;

    const distance = this._originalWidth + 32; // account for spacing
    const duration = Math.max(6, distance / 80); // consistent speed
    this.style.setProperty('--marquee-duration', `${duration}s`);

    this.classList.add('marquee-active');
  }

  stopMarquee() {
    this.classList.remove('marquee-active');
  }
}
customElements.define('promo-label', PromoLabel);

function isMobileView() {
  return window.matchMedia('(max-width: 990px)').matches;
}
function refreshDrawerAndBubble(openDrawer = true) {
 const cartDrawer = document.querySelector('cart-drawer') || document.querySelector('cart-notification');

  if (cartDrawer) {    
    fetch(`${routes.cart_url}?sections=cart-icon-bubble,cart-drawer`)
      .then(res => res.json())
      .then(parsedState => {      
        const cartBubble = parsedState['cart-icon-bubble'];
        const cartIcon = document.getElementById('cart-icon-bubble');
        const docu = new DOMParser().parseFromString(cartBubble, 'text/html');
        const newBubble = docu.querySelector('.cart-count-bubble');
        const currentBubble = cartIcon?.querySelector('.cart-count-bubble');

        if (newBubble) {
          if (currentBubble) {           
            currentBubble.replaceWith(newBubble);
          } else {           
            cartIcon.appendChild(newBubble);
          }
        } 

        const countEl = document.querySelector(
          '.cart-count-bubble span[aria-hidden="true"]'
        );

        const cartIconBubblemobile = document.querySelector('.mobile-header .icon-wrapper .bag .count-holder .cart-count-bubble');
        const cartIconBubblemobilecount = document.querySelector('.mobile-header .icon-wrapper .bag .count-holder .cart-count-bubble .cart-counter');
        if (cartIconBubblemobile && cartIconBubblemobilecount) {
          cartIconBubblemobilecount.textContent = parseInt(countEl.textContent, 10);
          cartIconBubblemobile.classList.toggle('hidden', parseInt(countEl.textContent, 10) === 0);
        }

        const htmlString = parsedState['cart-drawer'];
        if (!htmlString) return;

        const doc = new DOMParser().parseFromString(htmlString, 'text/html');
        const newCartDrawer = doc.querySelector('cart-drawer');        
        if (newCartDrawer) {
          cartDrawer.replaceWith(newCartDrawer);
          if (openDrawer) {                  
            setTimeout(() => {
              newCartDrawer.classList.add('animate', 'active');        
            }, 100);                      
          }
        }
      })
      .catch(err => console.error('Failed to update cart drawer:', err));
  }
}
function showGlobalCartToast() {
  if (!isMobileView()) return;

  injectGlobalCartToast();

  const toast = document.getElementById('global-cart-toast');
  if (!toast) return;

  toast.classList.add('is-visible');

  clearTimeout(toast._hideTimer);
  toast._hideTimer = setTimeout(() => {
    toast.classList.remove('is-visible');
  }, 3000);
}
function injectGlobalCartToast() {
  if (document.getElementById('global-cart-toast')) return;

  const toast = document.createElement('div');
  toast.id = 'global-cart-toast';
  toast.innerHTML = `
    <div class="global-cart-toast-inner">
      <span class="toast-icon">
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
          <circle cx="8" cy="8" r="8" fill="#00AF47"/>
          <path d="M4 8.5L6.5 11L12 5.5" stroke="#fff" stroke-width="1.6" fill="none"/>
        </svg>
      </span>
      <span class="toast-text">Item has been added to <a href="/cart" class="toast-link">Your bag</a></span>      
    </div>
  `;

  document.body.appendChild(toast);
}
function handleQuickAddPositioning() {
  const maxWidth = 990;
  const isMobile = window.innerWidth <= maxWidth;

  const observer = new ResizeObserver((entries) => {
    for (const entry of entries) {
      const card = entry.target.closest('.card-wrapper');
      const quickAddBtn = card?.querySelector('.quick-add_newEnh');
      if (quickAddBtn && isMobile) {       
        const contentHeight = entry.target.getBoundingClientRect().height;
        quickAddBtn.style.bottom = `${contentHeight}px`; // Adjust offset if needed        
      } else if (quickAddBtn && !isMobile) {
        // Reset styles for desktop view
        quickAddBtn.style.bottom = '0';
      }
    }
  });

  // Observe each .card__content (one-time setup)
  document.querySelectorAll('.card__content').forEach(el => observer.observe(el));
}
window.addEventListener('resize', () => {
  handleQuickAddPositioning();
});
function removeVariantError() {
  document.querySelector('.custom-variant-error')?.remove();
}
function showVariantError(message) {
  removeVariantError();

  const errorEl = document.createElement('div');
  errorEl.className = 'custom-variant-error';
  errorEl.innerHTML = `   
    <span>${message}</span>
  `;

  document.body.appendChild(errorEl);
  setTimeout(() => {
    removeVariantError();
  }, 3000);
}
document.addEventListener("DOMContentLoaded", function () {
  // banuba
  bindBanubaLifecycleEvents();
});
document.addEventListener('click', function (e) {
  const btn = e.target.closest('.custom-vto-btn');
  if (!btn) return;

  const banubaBtn = document.querySelector(
    '[data-block-id*="banuba_virtual_try_on_tint_block"] .tint-button-custom'
  );

  if (banubaBtn) {
    banubaBtn.click();
  } else {
    console.warn('Banuba VTO button not found');
  }
});
function getBanubaWidget() {
  return document.querySelector('tint-vto');
}
async function fetchDawnCartSections() {
  const [cartRes, sectionRes] = await Promise.all([
    fetch('/cart.js'),
    fetch(`${Shopify.routes.root}?sections=cart-drawer,cart-icon-bubble`)
  ]);

  const cart = await cartRes.json();
  const sections = await sectionRes.json();

  return { cart, sections };
}
async function refreshDawnCartUsingAPI() {
  const { cart, sections } = await fetchDawnCartSections();

  const cartDrawer = document.querySelector('cart-drawer');

  // Update cart drawer + bubble using Dawn's method
  if (!cartDrawer || typeof cartDrawer.renderContents !== 'function') return;

    cartDrawer.renderContents({
      items: cart.items,
      item_count: cart.item_count,
      sections: {
        'cart-drawer': sections['cart-drawer'],
        'cart-icon-bubble': sections['cart-icon-bubble']
      },      
      sections_url: window.location.pathname
    });
    const cartIconBubblemobile = document.querySelector('.mobile-header .icon-wrapper .bag .count-holder .cart-count-bubble');
    const cartIconBubblemobilecount = document.querySelector('.mobile-header .icon-wrapper .bag .count-holder .cart-count-bubble .cart-counter');
    if (cartIconBubblemobile && cartIconBubblemobilecount) {
      cartIconBubblemobilecount.textContent = cart.item_count;
      cartIconBubblemobile.classList.toggle('hidden', cart.item_count === 0);
    }
}
let banubaPopupOpen = false;
let lastCartItemCount = null;
let cartWatcher = null;

function startBanubaCartWatcher() {
  if (cartWatcher) return;

  cartWatcher = setInterval(async () => {
    if (!banubaPopupOpen) return;

    const res = await fetch('/cart.js');
    const cart = await res.json();
    // console.log(lastCartItemCount, cart.item_count);
    if (lastCartItemCount !== null) {
      if (cart.item_count > lastCartItemCount) {
        // Item added
        refreshDawnCartUsingAPI();
        fixEmptyDrawerState(cart);
        showBanubaToast('added');
        document.body.classList.add('banuba-vto-added');
      } 
      else if (cart.item_count < lastCartItemCount) {
        // Item removed
        refreshDawnCartUsingAPI();
        showBanubaToast('removed');
        document.body.classList.add('banuba-vto-added');
      }
    }
    lastCartItemCount = cart.item_count;
  }, 700);
}

function showBanubaToast(type = 'added') {
  const toast = document.getElementById('banuba-toast');
  if (!toast) return;

  const textEl = toast.querySelector('.banuba-toast-text');

  if (type === 'removed') {
    textEl.innerHTML = `Item has been removed from <a href="/cart" class="banuba-toast-link">Your bag</a>`;
  } else {
    textEl.innerHTML = `Item has been added to <a href="/cart" class="banuba-toast-link">Your bag</a>`;
  }
  toast.classList.add('is-visible');
  clearTimeout(toast._hideTimer);
  toast._hideTimer = setTimeout(() => {
    toast.classList.remove('is-visible');
  }, 3000); 
}

function fixEmptyDrawerState(cart) {
  if (!cart || cart.item_count === 0) return;

  const drawer = document.querySelector('cart-drawer');
  if (!drawer) return;

  drawer.classList.remove('is-empty');
  // Some Dawn versions also apply it on inner container
  drawer.querySelectorAll('.is-empty').forEach(el => {
    el.classList.remove('is-empty');
  });
}

function stopBanubaCartWatcher() {
  clearInterval(cartWatcher);
  cartWatcher = null;
}
function bindBanubaLifecycleEvents() {
  const widget = getBanubaWidget();
  if (!widget) return;

  widget.addEventListener('open', async () => {       
    banubaPopupOpen = true;
    injectBanubaToast();
    stopBanubaCartWatcher();
    const res = await fetch('/cart.js');
    const cart = await res.json();
    lastCartItemCount = cart.item_count;
   
    startBanubaCartWatcher();
  });

  widget.addEventListener('close', () => {    
    banubaPopupOpen = false;
    stopBanubaCartWatcher();
    document.body.classList.remove('banuba-vto-added');
     if (document.querySelector('cart-drawer')?.classList.contains('active')) {
      document.body.classList.remove('overflow-hidden');
      document.querySelector('cart-drawer').classList.remove('active');
    }  
    removeBanubaToast();
  });
}
function injectBanubaToast() {
  if (document.getElementById('banuba-toast')) return;

  const toast = document.createElement('div');
  toast.id = 'banuba-toast';
  // toast.textContent = 'Item has been added to Your bag';

  toast.innerHTML = `
    <div class="banuba-toast-inner">
      <span class="banuba-toast-icon">
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="8.00004" cy="7.99992" r="6.66667" fill="#00AF47"/>
          <path fill-rule="evenodd" clip-rule="evenodd" d="M11.1099 5.42368C11.3469 5.58203 11.4045 5.8938 11.2386 6.12002L7.57196 11.12C7.48624 11.2369 7.35229 11.3132 7.20384 11.3298C7.05538 11.3465 6.90656 11.3017 6.79484 11.207L4.17581 8.98475C3.9596 8.80129 3.94012 8.48526 4.13231 8.27887C4.32451 8.07248 4.65559 8.05389 4.87181 8.23735L7.05111 10.0864L10.3804 5.54656C10.5463 5.32034 10.8729 5.26532 11.1099 5.42368Z" fill="white"/>
        </svg>
      </span>
      <span class="banuba-toast-text">
        Item has been added to <a href="/cart" class="banuba-toast-link">Your bag</a>
      </span>      
    </div>
  `;

  document.body.appendChild(toast);
}
function removeBanubaToast() {
  const toast = document.getElementById('banuba-toast');
  toast?.remove();
}
function canAddVariantToCart(variantId, inventoryQty) {
  return fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
      if (!cart || !Array.isArray(cart.items)) return true;
      
      const totalQtyInCart = cart.items.reduce((total, item) => {
        return item.variant_id === variantId
          ? total + item.quantity
          : total;
      }, 0);

      return totalQtyInCart < inventoryQty;
    })
    .catch(() => true); 
}
